import { css } from 'styled-components';

export const titleMixin = css`
  font-weight: 600;
  font-size: 42px;
  line-height: 54px;
  text-align: center;
  color: #786f6f;
`;